(() => {
  'use-strict';

  const body = document.querySelector('body');

  const scroll = () => {
    const newScrollPos = (body.getBoundingClientRect()).top;

    // On homepage when there's a callback message, force sticky header to avoid weird spacing with the transparent header and the bobbin
    const messagesGroup = body.querySelector('.Messages .Messages-group');
    const homepageNode = body.querySelector('.Page.-homepage');
    const forceSticky = (homepageNode && messagesGroup);

    if (newScrollPos === 0 && !forceSticky) {
      body.classList.remove('-headerIsSticky');
    } else {
      body.classList.add('-headerIsSticky');
    }
  };

  window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
      scroll();
    });
  });

  scroll();
})();
